import { gql } from '@apollo/client';

// Allocates and holds the next available Case ID for 30 minutes, so two users adding a client at the
// same time cannot be handed the same number. Called when the user confirms in the Add Client modal
// that this is a new person.
export const RESERVE_CASE_ID = gql`
  mutation reserveCaseId($input: ReserveCaseIdInput!) {
    reservation: reserveCaseId(input: $input) {
      id
      caseId
      householdId
      householdCode
      expiresAt
    }
  }
`;

// Hands a held Case ID back to the pool when the user cancels out of the flow.
export const RELEASE_CASE_ID = gql`
  mutation releaseCaseId($caseId: String!) {
    reservation: releaseCaseId(caseId: $caseId) {
      id
      caseId
      status
    }
  }
`;
